import { CustomButton, Text } from '../../../shared/uiComponents';
import { Loader } from '../../../components/StyledComponents';

import { useSelector } from '../../../redux/store';

const RemoveTherapistsContent = ({ onClose, confirmHandler }: { confirmHandler: () => void; onClose: () => void }) => {
	const data = useSelector((state) => state.authorization.allocationData);
	const loading = useSelector((state) => state.authorization.loading);
	const clientInfo = useSelector((state) => state.client.client);

	return loading ? (
		<Loader />
	) : (
		<div>
			{data.map(({ totalHours, user }) => (
				<Text
					key={user.id}
					type="psm"
					fontWeight="medium"
					className="marginBottom16"
					title={`Are you sure you want to remove ${user.fullName} from ${clientInfo.fullName}?
  By removing this provider, ${totalHours} hours will be taken from their assigned hours and will become available for reassignment to another provider.`}
				/>
			))}
			<CustomButton title="Confirm" onClick={confirmHandler} className="marginBottom16" />
			<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} />
		</div>
	);
};

export default RemoveTherapistsContent;
